
/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import {BASE_URL} from '../utils/config'
import store from '../store'
import security from '../actions/security'

Vue.use(VueRouter)

const router = new VueRouter({
  base: BASE_URL,
  mode: 'history',
  routes
})


// security
router.beforeEach((to, from, next) => {
  const auth = store.state.security.auth
  to.hash.startsWith('#state=') && window.sessionStorage.setItem('isLogged', true)
  const isLogged = window.sessionStorage.getItem('isLogged')
  if (isLogged && !auth.authenticated) {
    security.init(next, to.meta.roles)
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/front/router/index.js